import HeroWithBackgroundColor from "./backgroundColor";
import HeroWithBackgroundImage from "./default";

const Heros = {
    HeroWithBackgroundColor,
    HeroWithBackgroundImage
}

export default Heros;
